// null , "" , undefined 체크 하는 함수
export const emptyCheck = (value) => {
  return (
    value === "" ||
    value === null ||
    value === undefined ||
    value === "undefined" ||
    (Array.isArray(value) && value.length === 0)
  );
};

/// ✅ 날짜 포맷팅
export const formatDate = (dateString) => {
  return dateString.split(" ")[0].replace(/-/g, ".");
};

// 날짜 형식을 변환하는 함수
export const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}.${month}.${day} ${hours}:${minutes}`;
};

/// ✅ firestore 날짜 형식으로 포맷팅 (현재시간)
export const formatDateTimeNowForFirestore = () => {
  const now = new Date();

  const pad = (n, digits = 2) => String(n).padStart(digits, "0");

  const year = now.getFullYear();
  const month = pad(now.getMonth() + 1);
  const day = pad(now.getDate());
  const hour = pad(now.getHours());
  const minute = pad(now.getMinutes());
  const second = pad(now.getSeconds());
  const millisecond = pad(now.getMilliseconds(), 3); // 3자리

  // 소수점 이하 6자리로 맞추기
  const microFake = millisecond + "000"; // 뒤에 000 추가

  return `${year}-${month}-${day} ${hour}:${minute}:${second}.${microFake}`;
};

/// ✅ 이름 마스킹 함수 (이**)
export const maskMiddleCharacters = (input) => {
  if (!input) return "없음";

  if (input.length === 1) {
    return input + "*";
  }

  if (input.length === 2) {
    return input[0] + "*"; 
  }
  const firstChar = input[0];
  const lastChar = input[input.length - 1];
  return `${firstChar}*${lastChar}`;
};

/// ✅ 천 자리 구분자 함수 (빈 값이 들어올 경우 0반환)
export const formatNumberWithCommas = (number) => {
  if (emptyCheck(number)) return "0";
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

/// ✅ firestore 날짜 형식으로 포맷팅 (한달 전)
export const formatDateTimeMonthAgoForFirestore = () => {
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  const pad = (n, digits = 2) => String(n).padStart(digits, "0");

  const year = oneMonthAgo.getFullYear();
  const month = pad(oneMonthAgo.getMonth() + 1);
  const day = pad(oneMonthAgo.getDate());
  const hour = pad(oneMonthAgo.getHours());
  const minute = pad(oneMonthAgo.getMinutes());
  const second = pad(oneMonthAgo.getSeconds());
  const millisecond = pad(oneMonthAgo.getMilliseconds(), 3); // 3자리

  // 소수점 이하 6자리로 맞추기
  const microFake = millisecond + "000"; // 뒤에 000 추가

  return `${year}-${month}-${day} ${hour}:${minute}:${second}.${microFake}`;
};
